import React from 'react';
import styled from 'styled-components';
import env from 'bench-environment';
import { colors } from 'bench-style-constants';

export const codes = {
  CHECK_BALANCE_CHECKER: 'RBKBALJ',
  CHECK_RECEIPTS: 'RBKRECN',
  CHECK_DOCUMENTS: 'RBKUPLN',
  CHECK_CLIENT_DETAILS: 'VBKANNJ',
  CHECK_PRECHECKS: 'RBKPRCJ',
};

export const MetaDataRow = styled.div`
  padding: 4px 0;
`;

export const Link = styled.a`
  font-size: 14px;
  color: ${colors.water};
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

type MetaDataLinkProps = {
  title: string;
  link: string;
};

const MetaDataLink = ({ title, link }: MetaDataLinkProps) => (
  <MetaDataRow>
    <Link href={link} target="_blank">
      {title}
    </Link>
  </MetaDataRow>
);

type MetaDataProps = {
  code: string;
  clientId: string;
  endDate: string;
  startDate: string;
};

const MetaData = ({ code, clientId, endDate, startDate }: MetaDataProps) => {
  switch (code) {
    case codes.CHECK_PRECHECKS:
      return MetaDataLink({
        title: 'Pre-Review Checklist',
        link: `https://us-west-2b.online.tableau.com/#/site/bench/views/Pre-reviewChecklist/Pre-reviewChecklistResults?Client%20ID=${clientId}&Review%20Scope%20Start=${startDate}&Review%20Scope%20End=${endDate}`,
      });
    case codes.CHECK_BALANCE_CHECKER:
      return MetaDataLink({
        title: 'Balance Checker',
        link: `${env.location.bkTools}/${clientId}/balance-checker`,
      });
    case codes.CHECK_RECEIPTS:
      // We want to show all receipts so we ignore the startDate and give an old, arbitrary date.
      return MetaDataLink({
        title: 'Receipts',
        link: `${env.location.bkTools}/${clientId}/unmatched-receipts/start/2000-01-01/end/${endDate}`,
      });
    case codes.CHECK_DOCUMENTS:
      return MetaDataLink({
        title: 'Uploads',
        link: `${env.location.bkTools}/${clientId}/upload`,
      });
    case codes.CHECK_CLIENT_DETAILS:
      return MetaDataLink({
        title: 'Client Details',
        link: `${env.location.bkTools}/${clientId}/details/card`,
      });
    default:
  }
  return null;
};

export default MetaData;
